/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { Button, Dropdown, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function DownloadTableData({
  data = [],
  columns = [],
  fileName = "export",
}) {
  const [loading] = useState(false);

  // ---------- CSV EXPORT ----------
  const downloadCSV = () => {
    if (!data.length) return message.warning("No data to download");

    const headers = columns.map((c) => c.title);
    const rows = data.map((row) => columns.map((c) => row[c.dataIndex] ?? ""));

    let csv = headers.join(",") + "\n";
    rows.forEach((r) => (csv += r.join(",") + "\n"));

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.csv`;
    link.click();
  };

  // ---------- PDF EXPORT ----------
  const downloadPDF = () => {
    if (!data.length) return message.warning("No data to download");

    const doc = new jsPDF();

    const tableColumn = columns.map((c) => c.title);
    const tableRows = data.map((row) =>
      columns.map((col) => row[col.dataIndex] ?? "")
    );

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      styles: { fontSize: 8 },
    });

    doc.text(fileName, 14, 10);
    doc.save(`${fileName}.pdf`);
  };

  const items = [
    { key: 1, label: "Download CSV", onClick: downloadCSV },
    { key: 2, label: "Download PDF", onClick: downloadPDF },
  ];

  return (
    <Dropdown menu={{ items }}>
      <Button icon={<DownloadOutlined />} type="primary" loading={loading}>
        Download
      </Button>
    </Dropdown>
  );
}
